import React from "react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { cn } from "@shared/ui/utils";

interface CustomCardProps {
  Icon: React.ReactNode;
  children: React.ReactNode;
  title: string;
  description: string;
  contentClass?: string;
  cardClass?: string;
  header?: React.ReactNode;
}

export const CustomCard = ({
  children,
  Icon,
  title,
  description,
  contentClass,
  cardClass,
  header,
}: CustomCardProps) => {
  return (
    <Card
      className={cn(
        "from-widget-radical-grad-center to-widget-radical-grad-bottom h-[626px] overflow-hidden rounded-3xl border-0 bg-radial-[at_25%_25%] from-47%",
        cardClass,
      )}
    >
      <CardHeader className="mb-[60px] flex flex-col px-6 pt-6">
        {Icon}
        <CardTitle className="mt-2 text-[18px] font-medium md:text-2xl">{title}</CardTitle>
        <CardDescription className="md:text-md text-static-secondary text-base md:leading-6">
          {description}
        </CardDescription>
        {header}
      </CardHeader>
      <CardContent className={cn("py-0", contentClass)}>{children}</CardContent>
    </Card>
  );
};
